import { t } from 'i18next';
import Invoice3Table1 from './Invoice3Table1';
import Invoice3Table2 from './Invoice3Table2';

const Invoice3 = ({ data }) => {
  const initialStock = data[0] || {};
  const total = data[data.length - 1] || {};
  const restStock = data[data.length - 2] || {};

  const dateStr = initialStock.date || '';
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = date.getMonth();

  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const firstPage = [
    ...data.slice(1, Math.min(data.length - 1, 16)),
    ...Array.from({ length: Math.max(15 - (data.length - 2), 0) }, () => ({})),
  ].slice(0, 15);

  const secondPageLength = daysInMonth - 15;
  const secondPage = [
    ...data.slice(16, data.length - 1),
    ...Array.from({ length: Math.max(secondPageLength - (data.length - 16), 0) }, () => ({})),
  ].slice(0, secondPageLength);

  return (
    <>
      <div
        id="page1"
        style={{
          height: '210mm',
          width: '297mm',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        <section
          style={{
            width: '100%',
            paddingLeft: '6mm',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={{ width: '12%' }}>
            <img src={'/logo.jpeg'} alt="Logo" style={{ height: '100%', width: '100%' }} />
          </div>
          <div
            style={{
              width: '70%',
              height: '1mm',
              backgroundColor: '#047bcb',
            }}
          ></div>
        </section>
        <div style={{ margin: '-2mm 0 0.5mm 0', width: '100%', padding: '0 0 0 4mm', fontWeight: 700 }}>
          {t('inventoryPage.pdfHeading')}
        </div>
        <section
          style={{
            width: '100%',
            height: 'max-content',
            display: 'flex',
            justifyContent: 'center',
            gap: '2mm',
            padding: '0 4mm 0 4mm',
          }}
        >
          <Invoice3Table1 rows={firstPage} />
          <Invoice3Table2 heading={'cement'} rows={firstPage} initialStock={initialStock.totalCementAdd} />
          <Invoice3Table2 heading={'sand'} rows={firstPage} initialStock={initialStock.totalSandAdd} />
          <Invoice3Table2 heading={'gravel815'} rows={firstPage} initialStock={initialStock.totalGravel815Add} />
          <Invoice3Table2 heading={'gravel1525'} rows={firstPage} initialStock={initialStock.totalGrave1525Add} />
        </section>
      </div>
      <div
        id="page2"
        style={{
          height: '210mm',
          width: '297mm',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        <section
          style={{
            width: '100%',
            height: 'max-content',
            display: 'flex',
            justifyContent: 'center',
            gap: '2mm',
            padding: '0 4mm 0 4mm',
          }}
        >
          <Invoice3Table1 rows={secondPage} isSecondPage={true} total={{ total: total.totalConcrete }} />
          <Invoice3Table2
            heading={'cement'}
            rows={secondPage}
            total={{ totalAdd: total.totalCementAdd || 0, totalSub: total.totalCementSub || 0 }}
            restStock={{ rest: restStock.totalCementSub }}
          />
          <Invoice3Table2
            heading={'sand'}
            rows={secondPage}
            total={{ totalAdd: total.totalSandAdd || 0, totalSub: total.totalSandSub || 0 }}
            restStock={{ rest: restStock.totalSandSub }}
          />
          <Invoice3Table2
            heading={'gravel815'}
            rows={secondPage}
            total={{ totalAdd: total.totalGravel815Add || 0, totalSub: total.totalGravel815Sub || 0 }}
            restStock={{ rest: restStock.totalGravel815Sub }}
          />
          <Invoice3Table2
            heading={'gravel1525'}
            rows={secondPage}
            total={{ totalAdd: total.totalGrave1525Add || 0, totalSub: total.totalGrave1525Sub || 0 }}
            restStock={{ rest: restStock.totalGrave1525Sub }}
          />
        </section>
      </div>
    </>
  );
};

export default Invoice3;
